import { render, staticRenderFns } from "./SerieTreatment.vue?vue&type=template&id=3e82bf6e&scoped=true"
import script from "./SerieTreatment.vue?vue&type=script&lang=js"
export * from "./SerieTreatment.vue?vue&type=script&lang=js"
import style0 from "./SerieTreatment.vue?vue&type=style&index=0&id=3e82bf6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e82bf6e",
  null
  
)

export default component.exports